module.exports = __webpack_public_path__ + "img/service-item-2.f5830f93.jpeg";